import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { api } from "@/pages/Admin";

const inputCls = "w-full bg-[#08080c] border border-white/15 px-3 py-2.5 text-sm text-white placeholder:text-slate-600 focus:border-[#00f0ff]";

export const ImageUpload = ({ value, onChange, testPrefix }) => {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try {
      const { data } = await api.post("/upload/image", fd);
      onChange(`${process.env.REACT_APP_BACKEND_URL}${data.url}`);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Upload failed");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="flex gap-3 items-start">
      {value && <img src={value} alt="preview" className="w-16 h-16 object-cover border border-white/15 shrink-0" />}
      <div className="flex-1 space-y-2">
        <div className="flex gap-2">
          <input data-testid={`${testPrefix}-url`} value={value} onChange={(e) => onChange(e.target.value)} placeholder="Image URL or upload from computer" className={inputCls} />
          <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" onChange={upload} className="hidden" data-testid={`${testPrefix}-file`} />
          <button
            type="button"
            data-testid={`${testPrefix}-upload-button`}
            onClick={() => fileRef.current?.click()}
            disabled={uploading}
            className="shrink-0 flex items-center gap-2 px-4 py-2.5 bg-[#00ff66] text-black font-mono-tech text-[10px] tracking-[0.2em] uppercase font-bold hover:bg-white transition-colors disabled:opacity-50"
          >
            {uploading ? <Loader2 size={13} className="animate-spin" /> : <Upload size={13} />}
            {uploading ? "Uploading" : "Upload"}
          </button>
        </div>
        <p className="font-mono-tech text-[9px] tracking-[0.15em] uppercase text-slate-600">JPEG / PNG / WEBP / GIF — max 5MB</p>
      </div>
    </div>
  );
};
